import { Add, GridView } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import HeaderTable from "../../Components/HeaderTable/HeaderTable";
import ModalContainer from "../../Components/Modal/ModalContainer";
import { ButtonTable } from "../../Layouts/ButtonsControlled";
import { openModal } from "../../Redux/modalSlice";

const Leads = () => {
  const location = useLocation();
  const path = location.pathname.split("/")[2];
  const dispatch = useDispatch();

  return (
    <>
      <ModalContainer>{/* <CreateUtility /> */}</ModalContainer>
      <HeaderTable>
        <div className="title">
          <GridView />
          <span>{path}</span>
        </div>
        {/* <ButtonTable startIcon={<Add />} onClick={() => dispatch(openModal())}>
          New
        </ButtonTable> */}
      </HeaderTable>

      <Outlet />
    </>
  );
};

export default Leads;
